export default __webpack_public_path__ + "static/iphone-03c194e4a58b7a66f10f83e9ee513adb.png";